import { render } from "./taskedit.vue?vue&type=template&id=38562d5e&scoped=true"
import script from "./taskedit.vue?vue&type=script&lang=js"
export * from "./taskedit.vue?vue&type=script&lang=js"

import "./taskedit.vue?vue&type=style&index=0&id=38562d5e&scoped=true&lang=scss"

import exportComponent from "D:\\startup\\gtdhtml5\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38562d5e"]])

export default __exports__